module.exports = __webpack_public_path__ + "static/media/hotel-black.ccb3b7ba.svg";